import { Link } from 'react-router-dom';

import { cn } from '@/shared/utils/cn';
import { LinkButtonProps } from '@/shared/types/CommonTypes';

const baseClasses = 'inline-flex items-center font-medium no-underline';

const variantClasses = {
  primary:
    'justify-center rounded-full bg-[#95699f] text-white hover:bg-[#81528e] font-semibold',
  text: 'text-[#666] hover:text-[#95699f]',
  underline: 'text-[#444] underline',
} as const;

const LinkButton = ({
  children,
  variant = 'text',
  leftIcon,
  rightIcon,
  className,
  ref,
  ...props
}: LinkButtonProps) => {
  return (
    <Link
      ref={ref}
      className={cn(baseClasses, variantClasses[variant], className)}
      {...props}
    >
      {leftIcon && <span>{leftIcon}</span>}
      {children}
      {rightIcon && <span>{rightIcon}</span>}
    </Link>
  );
};

export default LinkButton;
